/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Pagination dan get Data   |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

export const PaginationDataPesertaSertifikasi = {
    data() {
      return {
        items: [],
        indexed: '',
        formFilter : {
            id_sertifikasi : '',
            status_pembayaran : '',
            periode : ''
        },
        searchDataPesertaSertifikasi : "",
        id_sertifikasi : "",
        pageSize : "10",
        currentPageDataPesertaSertifikasi :0,
        timeout: 0,
        pagination: {
            totalPages: 0
        },
        no: 1,
      };
    },
    watch: {
        searchDataPesertaSertifikasi: function (val) {
            // comment console console.log(val);
            clearTimeout(this.timeout);
            var vm = this
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                var searchVar = vm.ltrim(vm.searchDataPesertaSertifikasi)

                vm.getData("0", vm.pageSize,searchVar,vm.formFilter.id_sertifikasi,vm.formFilter.status_pembayaran,vm.formFilter.periode);
            }, 1000);
           
        },
     
        /**
         * 
         * End Data Peserta Sertifikasi RPl 
         */
        currentPageDataPesertaSertifikasi: function(val) {
            //alert val -1 
            var page = val - 1;
            this.indexed = page * 10;

            this.getData(val - 1, this.pageSize, this.searchDataPesertaSertifikasi, this.formFilter.id_sertifikasi, this.formFilter.status_pembayaran,this.formFilter.periode );
            
        }
    },
    methods: {
        /**
         * 
         * Data Peserta Sertifikasi  
         */
        ltrim(str) {
            if(!str) return str;
            return str.replace(/^\s+/g, '');
        },
        changePageSize(e) {
            // comment console console.log(e.target.value);
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }

            this.getData("0", this.pageSize, this.searchDataPesertaSertifikasi, this.formFilter.id_sertifikasi, this.formFilter.status_pembayaran,this.formFilter.periode );
        },
    }
  };